module.exports = __webpack_public_path__ + "img/music-work-icon14.60b15449.png";